var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"infoboard-title\">"
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Images",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":29},"end":{"line":1,"column":53}}}))
    + "</div>\n<fieldset>\n    <section class=\"form-group\">\n        <div class=\"col-sm-12\">\n            <input type=\"file\" class=\"form-control flat\" name=\"imagens\" multiple/>\n        </div>\n    </section>\n</fieldset>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/points-edit-upload.hbs
// module id = Gn+j
// module chunks = 1